import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit = 20, ellipsis = '...'): any {
    if (value.length > limit) {
      return value.substring(0, limit) + ellipsis;
    }
    return value;
  }

}
